__turbopack_context__.v({
  "backButton": "ImageGallery-module__VNeqBq__backButton",
  "carousel": "ImageGallery-module__VNeqBq__carousel",
  "dot": "ImageGallery-module__VNeqBq__dot",
  "dotActive": "ImageGallery-module__VNeqBq__dotActive",
  "dots": "ImageGallery-module__VNeqBq__dots",
  "gallery-fade": "ImageGallery-module__VNeqBq__gallery-fade",
  "grid": "ImageGallery-module__VNeqBq__grid",
  "gridCell": "ImageGallery-module__VNeqBq__gridCell",
  "gridImage": "ImageGallery-module__VNeqBq__gridImage",
  "hero": "ImageGallery-module__VNeqBq__hero",
  "heroFullWidth": "ImageGallery-module__VNeqBq__heroFullWidth",
  "heroImage": "ImageGallery-module__VNeqBq__heroImage",
  "imageCredit": "ImageGallery-module__VNeqBq__imageCredit",
  "imageCreditGradient": "ImageGallery-module__VNeqBq__imageCreditGradient",
  "loadingState": "ImageGallery-module__VNeqBq__loadingState",
  "modalContent": "ImageGallery-module__VNeqBq__modalContent",
  "modalGalleryRegion": "ImageGallery-module__VNeqBq__modalGalleryRegion",
  "modalOverlay": "ImageGallery-module__VNeqBq__modalOverlay",
  "modalPanel": "ImageGallery-module__VNeqBq__modalPanel",
  "relative": "ImageGallery-module__VNeqBq__relative",
  "scrollTrack": "ImageGallery-module__VNeqBq__scrollTrack",
  "seeAllButton": "ImageGallery-module__VNeqBq__seeAllButton",
  "seeAllChipButton": "ImageGallery-module__VNeqBq__seeAllChipButton",
  "seeAllChipContent": "ImageGallery-module__VNeqBq__seeAllChipContent",
  "seeAllChipLabel": "ImageGallery-module__VNeqBq__seeAllChipLabel",
  "slide": "ImageGallery-module__VNeqBq__slide",
  "slideImage": "ImageGallery-module__VNeqBq__slideImage",
  "srOnly": "ImageGallery-module__VNeqBq__srOnly",
  "wrapper": "ImageGallery-module__VNeqBq__wrapper",
});
